import { render, staticRenderFns } from "./CmgGroupOrderError.vue?vue&type=template&id=6d4e9da5&scoped=true&lang=pug"
import script from "./cmg-group-order-error.ts?vue&type=script&lang=ts&external"
export * from "./cmg-group-order-error.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgGroupOrderError.vue?vue&type=style&index=0&id=6d4e9da5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e9da5",
  null
  
)

export default component.exports